import { Component, OnInit } from "@angular/core";
import { ModalController, ToastController } from "@ionic/angular";
import { BlockchainDetailModelResponse } from "src/app/model/BlockchainDetailModelResponse";
import { PeerWiseResponse } from "src/app/model/PeerWiseResponse";
import { BlockchainApplicationService } from "src/app/services/blockchain-application.service";

@Component({
  selector: "app-verify-blockchain",
  templateUrl: "./verify-blockchain.component.html",
  styleUrls: ["./verify-blockchain.component.scss"],
})
export class VerifyBlockchainComponent implements OnInit {

  data: BlockchainDetailModelResponse;
  isLoading: boolean = false;
  peersVerificationResponse: {[key: string]: string};
  
  constructor(
    private modalCtrl: ModalController,
    private blockchainApplicationService: BlockchainApplicationService
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.blockchainApplicationService.verify(this.data?.bctxid).subscribe(async (data) => {
      if(data.status === 'SUCCESS') {
        this.peersVerificationResponse = data.peersVerificationResponse;
      }
      else {
        this.blockchainApplicationService.errorToast(data.errorMessage);
      }
    }, (error) => {
      console.log(error);
      this.isLoading = false;
      this.blockchainApplicationService.errorToast(error?.error?.errorMessage||error?.errorMessage);
    });
  }

  peerWiseStatus(peerStatus) {
    return peerStatus === 'VERIFIED' ? "success": "failure";
  }

  cancel() {
    return this.modalCtrl.dismiss(null, "cancel");
  }
}
